import React from "react";
import './Delivery.css'; // Optional: Add custom styles for this component

const Delivery = () => {
  return (
    <div className="delivery-section">
      <h1>Delivery Information</h1>
      <p>We ensure your meals are delivered hot and on time, every time. Here’s how we handle deliveries:</p>
      <ul>
        <li>Fast and reliable delivery services.</li>
        <li>Tracked delivery status.</li>
        <li>Flexible delivery times based on your schedule.</li>
      </ul>
    </div>
  );
};

export default Delivery;